import React from 'react'
import { AppBar as MuiAppBar, Box, Divider, Toolbar } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useGoBack } from 'infrastructure/routing'
import { useCurrentUserRedirectResource } from 'infrastructure/auth/auth.hooks'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { drawOpenToggleAtom } from '../state'

export function AppBar() {
  const userData = useCurrentUserRedirectResource()
  const goBack = useGoBack()

  const drawerToggle = useSetAtom(drawOpenToggleAtom)

  return (
    <MuiAppBar>
      <Toolbar variant="dense">
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={drawerToggle}
        >
          <MenuIcon />
        </IconButton>
        <Divider orientation="vertical" flexItem />
        <Box ml="0.5em" mr="0.5em">
          {userData.data?.name}
        </Box>
        <Divider orientation="vertical" flexItem />
        <IconButton onClick={goBack} color="inherit">
          <ArrowBackIcon />
        </IconButton>
        <Divider />
      </Toolbar>
    </MuiAppBar>
  )
}
